module.exports = __webpack_public_path__ + "assets/img/Future_PerlotBascoules.00fa5145-ps.jpg";